import React from 'react';

import { Container, Section } from 'components';
import { NotificationsList, NotificationsReceiveOptions } from 'components/pages/notifications';

import styles from './Notifications.module.scss';

const Notifications = () => {
  return (
    <Section>
      <Container>
        <div className={styles.layout}>
          <NotificationsList />
          <NotificationsReceiveOptions />
        </div>
      </Container>
    </Section>
  );
};

export default Notifications;
